import styled from "styled-components"

import {Card} from "@irati/ui/src/Layout"
import {twoPxShadow} from "@irati/ui/src/global/elevation"

export default styled(Card)`
  ${twoPxShadow}
`
